{
  "TelnosmovedtoLabel": "N. di tel. Spostato a:",
  "DevicesmovedfromLabel": "Dispositivo\/i spostato\/i da:",
  "AcdagentsmovedfromLabel": "Agente\/i ACD Trasferito\/i da:",
  "CallsegmentnumberLabel": "Numero del segmento di chiamata:",
  "CallsegmentnumberAnyOptionLabel": "[Qualsiasi]",
  "CallsegmentnumberFirstOptionLabel": "[Prima]",
  "Callsegmentnumber2OptionLabel": "2",
  "Callsegmentnumber3OptionLabel": "3",
  "Callsegmentnumber4OptionLabel": "4",
  "Callsegmentnumber5OptionLabel": "5",
  "Callsegmentnumber6plusOptionLabel": "6+",
  "CallsegmentnumberLastOptionLabel": "[Ultimo]",
  "CallsegmentstartreasonLabel": "Motivo dell'inizio del segmento di chiamata:",
  "CallsegmentstartreasonAnyOptionLabel": "[Qualsiasi]",
  "CallsegmentstartreasonDivertedtoOptionLabel": "Deviato a",
  "CallsegmentstartreasonOverflowedinOptionLabel": "Tracimato in",
  "CallsegmentstartreasonAdvancedtoOptionLabel": "Avanzato a",
  "CallsegmentstartreasonTransferredtoOptionLabel": "Trasferito a",
  "CallsegmentstartreasonConferencedtoOptionLabel": "Conferito a",
  "CallsegmentstartreasonConferencedegenOptionLabel": "Conferenza De\/Gen",
  "CallsegmentendreasonLabel": "Motivo della fine del segmento di chiamata:",
  "CallsegmentendreasonAnyOptionLabel": "[Qualsiasi]",
  "CallsegmentendreasonDivertedfromOptionLabel": "Deviato da",
  "CallsegmentendreasonOverflowedoffOptionLabel": "Traboccato Spento",
  "CallsegmentendreasonAdvancedfromOptionLabel": "Avanzato Da",
  "CallsegmentendreasonTransferredfromOptionLabel": "Trasferito da",
  "CallsegmentendreasonConferencedfromOptionLabel": "Conferito da",
  "CallsegmentendreasonConferencedegenOptionLabel": "Conferenza De\/Gen",
  "CallsegmentendreasonConsultationtrtoOptionLabel": "Consultazione Tr\/To",
  "CallsegmentendreasonMovedtoconferenceOptionLabel": "Spostato in conferenza",
  "CallsegmentendreasonMovedtoparkOptionLabel": "Spostati nel parco",
  "CallsegmentendreasonMovedtovoicemailOptionLabel": "Spostato nella posta vocale",
  "CallsegmentendreasonEndedonholdonlyOptionLabel": "Terminato solo in attesa",
  "CallsegmentendreasonEndedonholdexclOptionLabel": "Terminato In attesa Escluso",
  "CallsegmentendreasonUnmonitoreddestOptionLabel": "Destinazione non monitorata",
  "CallsegmentendreasonUnknowndestOptionLabel": "Destinazione sconosciuta",
  "CallsegmentendreasonAllunrslvddestonlyOptionLabel": "Solo tutte le destinazioni non risolte",
  "CallsegmentendreasonAllunrslvddestexclOptionLabel": "Tutte le destinazioni non risolte escluse",
  "CallsegmentendreasonModellingerrorsonlyOptionLabel": "Solo errori di modellazione",
  "CallsegmentendreasonModellingerrorsexclOptionLabel": "Errori di modellizzazione esclusi",
  "CallsegmentendreasonApplicationendedOptionLabel": "Applicazione Terminata",
  "CallsegmentendreasonDevicedeletedOptionLabel": "Dispositivo eliminato",
  "CallsegmentendreasonNoreplyneededEmailsexcludedOptionLabel": "Nessuna risposta necessaria Email escluse",
  "CallsegmentchainidLabel": "ID catena del segmento di chiamata (ID di chiamata dell'applicazione):",
  "CallMovementFiltering_SectionHeader": "Filtraggio del movimento delle chiamate",
  "CallMovementFiltering_AnyPlaceholder": "[Qualsiasi]",
  "NAME": "CallMovementFiltering",
  "AcdagentsmovedfromLabel_MST": "Agente\/i trasferito\/i da:",
  "CallsegmentstartreasonEscapedtoOptionLabel": "Fuggito verso",
  "CallsegmentendreasonEscapedfromOptionLabel": "Fuggito"
}